import { useState } from "react";
import AjvErrors from "ajv-errors";
import addFormats from "ajv-formats";
import Ajv from "ajv";
import dayjs from "dayjs";


const ajv = new Ajv({
  allErrors: true,
  coerceTypes: true
});

addFormats(ajv);
AjvErrors(ajv);

// Добавляем кастомное ключевое слово для валидации даты
ajv.addKeyword('isValidDate', {
  type: 'string',
  validate: (schema, data, _keyword, _cxt) => {
    const format = schema.format;

    if(format) {
      return dayjs(data, format, true).isValid();
    }
    
    if (schema === true) {
      return dayjs(data).isValid();
    }  
  },
  errors: true,
});

/**
 * Хук для валидации входных данных.
 *
 * @param {ValidationSchema} schema : Схема валидация, которая должна соответствовать формату ajv. Описываем все поля.
 * @param {Data} data               : Объект входных данных.
 *
 * @returns {Object}                : Возвращает функцию validate и обьект с ошибками { nameField: message }, которые можно передать в компонент error и helperText.
 */
function useValidate({ schema, data }) {
  const [errors, setErrors] = useState({});

  /**
   * Функция для вызова валидации
   * @returns {Object} :Возвращает true если валидация прошла успешно и обновляет errors
   */
  const validate = () => {
    const newData = filterNonNullValues(data);
    const valid = ajv.validate(schema, newData);
    if (valid) {
      setErrors({});
      return true;
    }

    const validateData = {};
    for (const error of (ajv.errors)) {
      const errorHandler = errorHandlers[error.keyword] || errorHandlers.type;
      errorHandler(error, validateData);
    }
    setErrors(validateData);
    return valid;
  };

  return {
    validate,
    errors,
  };
}
export default useValidate;

/**
 * Функция для фильтрации null и undefined и ''. Также создает клон объекта, чтобы не модифицровать старый.
 * Далее фильтруем пустые значения
 *
 * @param {Object} obj  : Схема валидация, которая должна соответствовать формату ajv. Описываем все поля.
 *
 * @returns {Object} : Возвращает объект без null и undefined
 */
const filterNonNullValues = (obj) => {
  const cloneData = JSON.parse(JSON.stringify(obj));
  const filteredObject = {};
  for (const key in cloneData) {
    const value = cloneData[key];

    if (value !== null && value !== undefined && value !== "") {
      filteredObject[key] = isNaN(value) ? value : +value;
    }
  }
  return filteredObject;
}

/**
 * Объект для описании ошибки. При необходимости расширять его.
 */
const errorMessages = {
  required: "Поле обязательное",
  string: "Поле должно содержать только строку",
  number: "Поле должно содержать только цифры",
  maximum: "Максимальное значение = ",
  minimum: "Минимальное значение = ",
  maxLength: "Максимальное количество символов ограничено ",
  minLength: "Минимальное количество символов ",
  email: 'Недопустимое значение для поля ',
  isValidDate: "Некорректно введена дата",
};

/**
 * Обработчик ошибок валидации и постановки сообщения об ошибке
 */
const errorHandlers = {
  required: (error, validateData) => {
    validateData[error.params.missingProperty] = errorMessages?.required;
  },
  maximum: (error, validateData) => {
    validateData[error.instancePath.slice(1)] = `${errorMessages?.maximum} ${error.params.limit}`;
  },
  minimum: (error, validateData) => {
    validateData[error.instancePath.slice(1)] = `${errorMessages?.minimum} ${error.params.limit}`;
  },
  maxLength: (error, validateData) => {
    validateData[error.instancePath.slice(1)] = `${errorMessages?.maxLength} ${error.params.limit}`;
  },
  minLength: (error, validateData) => {
    validateData[error.instancePath.slice(1)] = `${errorMessages?.minLength} ${error.params.limit}`;
  },
  type: (error, validateData) => {
    (validateData[error.instancePath.slice(1)]) = errorMessages[error.params.type] || error.message;
  },
  format: (error, validateData) => { 
    validateData[error.instancePath.slice(1)] = `${errorMessages.email} ${error.instancePath.slice(1)}`;
  },
  isValidDate: (error, validateData) => {
    validateData[error.instancePath.slice(1)] = `${errorMessages.isValidDate} ${error.instancePath.slice(1)}`
  },
};